// shared/domain/productor.js  (reglas puras sobre productores/cuentas)

/** Iniciales (máx. 2) para el avatar: "juan perez lopez" -> "JP". */
export const iniciales = nombre => {
  const words = String(nombre || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  return words
    .slice(0, 2)
    .map(w => w.charAt(0).toUpperCase())
    .join('');
};

/** Resuelve ids seleccionados contra el catálogo; los ausentes se muestran como "Productor {id}" con 0 parcelas. */
export const resolverProductores = (ids = [], catalogo = []) => {
  const byId = new Map(catalogo.map(p => [p.id, p]));
  return ids.map(id => byId.get(id) || { id, nombre: `Productor ${id}`, total_parcelas: 0 });
};

/** Opciones disponibles = catálogo sin los ya seleccionados. */
export const productoresDisponibles = (catalogo = [], ids = []) => catalogo.filter(p => !ids.includes(p.id));

/** "1 parcela" / "N parcelas". */
export const etiquetaParcelas = total => `${total} ${total === 1 ? 'parcela' : 'parcelas'}`;

const PALETA_AVATAR = [
  { background: '#E4EFC6', color: '#3F5A0A' }, // verde
  { background: '#FBE3CC', color: '#8A4A12' }, // naranja / café
  { background: '#DCE8F9', color: '#1F3A6B' }, // azul / marino
  { background: '#E9EBEE', color: '#5B6470' }, // gris
];

/** Color de avatar determinista por id de productor: { background, color }. */
export const colorAvatar = id => {
  const n = Math.abs(Number(id)) || 0;
  return PALETA_AVATAR[n % PALETA_AVATAR.length];
};

/** Texto sobre el que se busca un productor: nombre, código y comunidad (el filtro ignora acentos y mayúsculas). */
export const stringifyProductor = p => `${p.nombre || ''} ${p.codigo || ''} ${p.localidad || ''}`;

/** Segunda línea de una opción: "Código: X · Comunidad: Y" (omite las partes vacías). */
export const detalleProductor = p =>
  [p.codigo ? `Código: ${p.codigo}` : '', p.localidad ? `Comunidad: ${p.localidad}` : ''].filter(Boolean).join(' · ');
